import React from 'react';
// template components
import AssistiveText from '@nmx/template/dist/componentLibrary/components/AssistiveText';
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';
import WidowBlock from '@nmx/template/dist/componentLibrary/components/WidowBlock';
// styles
import { SectionContainerFafaBannerStyled } from './styles';

export default () => {
  return (
    <SectionContainerFafaBannerStyled
      id='fafa-page-get-matched-banner'
      backgroundVariant='lightA'
      themeType='lightTheme'>
      <Row align='center'>
        <Col align='center'>
          <AssistiveText component='h1'>
            Find a Financial Advisor
          </AssistiveText>
          <Typography
            align='center'
            component='h2'
            nextElement='typography'>
            Looks like you&#39;ve <WidowBlock>been matched.</WidowBlock>
          </Typography>
          <Typography
            align='center'
            disableBottomPadding>
            They&#39;re your go&#45;to financial professional who&#39;ll answer any questions you have and help you make the best financial choices so you can reach your goals. Feel free to connect anytime.
          </Typography>
        </Col>
      </Row>
    </SectionContainerFafaBannerStyled>
  );
};
